<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Capital aberto, EUA e Austrália</h2>
          <p>
            O ano de 2007 é decisivo. A JBS abre o capital na bolsa de valores
            de São Paulo por meio do maior IPO já registrado até aquela data no
            mercado nacional. A empresa passa a se chamar JBS em homenagem a
            José Batista Sobrinho e adquire a <strong>Swift</strong> nos Estados
            Unidos e na Austrália. Com isso, inicia uma operação industrial
            relevante nos dois países e unifica a marca centenária
            <strong>Swift</strong> sob uma mesma empresa, passando a operar
            unidades de processamento de suínos e ovinos.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2007/2007-1.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2007/05/30/g/20070530-41497-nac-28-eco-b14-not-qwgpxha.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2007/2007-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2007/09/15/g/20070915-41605-spo-49-eco-b12-not-hxhsqka.jpg'
              )
            "
            class="secondItem"
          />
          <img
            src="../assets/img/2007/2007-3.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2007/05/30/g/20070530-41497-nac-29-eco-b15-not-axgpxha.jpg'
              )
            "
            class="secondItem"
          />
          <img
            src="../assets/img/2007/2007-4.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2007/03/28/g/20070328-41434-spo-34-eco-b17-not-wheheha.jpg'
              )
            "
            class="secondItem"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>Cresce a busca por comida orgânica</h2>
          <p>
            Se entre as décadas de 1970 e 1990 a demanda de alimentos
            processados aumentou, ao longo dos anos 2000 surgiram movimentos de
            consumidores buscando outras alternativas, como a comida orgânica,
            por exemplo.
          </p>
          <div class="imagens">
            <img
              src="../assets/img/2007/2007-5.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/1998/02/05/g/19980205-38095-spo-0015-ger-a15-not-ksasxqw.jpg'
                )
              "
            />
            <img
              src="../assets/img/2007/2007-6.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/2011/07/18/g/20110718-43007-spo-33-cid-c6-not-seepqqe.jpg'
                )
              "
            />
            <img
              src="../assets/img/2007/2007-7.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/2007/02/21/g/20070221-41399-spo-21-eco-b10-not-hagxxea.jpg'
                )
              "
            />
            <span
              ><i class="icon-eye"></i
              ><strong>clique nas imagens para ampliar</strong></span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 160px;
    display: grid;
    grid-template-columns: 350px max-content 1fr;
    gap: 60px;
    justify-content: space-between;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        @include media('<=desktop') {
          padding: 0 20px;
        }
        img {
          display: block;
          &:nth-child(2) {
            margin-top: -150px;
            transform: translateX(150px);
          }
          &:nth-child(3) {
            margin-top: -100px;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        margin-top: 130px;
        margin-left: -50px;
        @include media('<=desktop') {
          background: color(cGreen);
          padding: 40px 20px;
          margin: 0;
        }
        .imagens {
          margin: 30px auto;
          text-align: center;
          img {
            margin-bottom: 20px;
          }
        }
        @include media('>desktop') {
          .imagens {
            margin-top: 50px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 17px;
            img {
              &:nth-child(2) {
                grid-row: span 2;
              }
            }
          }
        }
        span {
          display: block;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          text-align: left;
          margin-left: 30px;
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          max-width: 318px;
          margin-left: auto;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-bottom: 20px;
          max-width: 318px;
          margin-left: auto;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          &::before {
            content: '\e901';
            font-family: 'icomoon' !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: '';
      background: color(cGreen);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        display: none;
      }
    }
  }
}
</style>
